import template from './userInfoPanel.html';
import controller from './userInfoPanel.controller';

let userInfoPanelComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default userInfoPanelComponent;



// WEBPACK FOOTER //
// ./app/components/userInfoPanel/userInfoPanel.component.js